"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.toMediaQuery = toMediaQuery;
/* eslint-disable import/prefer-default-export */

var Breakpoints = {
  xs: {
    minPx: 320,
    maxPx: 479
  },
  sm: {
    minPx: 480,
    maxPx: 767
  },
  md: {
    minPx: 768,
    maxPx: 991
  },
  lg: {
    minPx: 992,
    maxPx: 1199
  },
  xl: {
    minPx: 1200
  }
};

function toMediaQuery(_ref) {
  var min = _ref.min,
      max = _ref.max;
  var queryString = null;

  if (!min && !max) {
    throw new Error("either 'min' or 'max' is required");
  }

  if (min) {
    var rule = Breakpoints[min.toLowerCase()];

    if (!rule) {
      throw new Error("Min breakpoint not found: ".concat(min));
    }

    queryString = "(min-width: ".concat(rule.minPx, "px)");
  }

  if (max) {
    var _rule = Breakpoints[max.toLowerCase()];

    if (!_rule) {
      throw new Error("Max breakpoint not found: ".concat(max));
    }

    if (queryString) {
      queryString += " and (max-width: ".concat(_rule.maxPx, "px)");
    } else {
      queryString = "(max-width: ".concat(_rule.maxPx, "px)");
    }
  }

  return queryString;
}